import React from 'react';
import PropTypes from 'prop-types';

export const RichContent = (props) => {
	return (<div className="rich-text" dangerouslySetInnerHTML={{__html: props.dangerous}}/>);
};

RichContent.propTypes = {
	dangerous: PropTypes.any
};




// WEBPACK FOOTER //
// src/client/components/common/CMS/elements/RichContent.js